import { FC } from 'react'
import LogoMini from './logo/LogoMini'

const Loading: FC<{
  isfullScreen?: boolean
  noText?: boolean
  size?: 'tiny' | 'small' | 'medium' | 'large'
}> = ({ isfullScreen, noText = false, size = 'medium' }) => (
  <div
    className={`
    animate-pulse flex justify-center items-center w-full
    ${isfullScreen ? 'min-h-screen' : 'min-h-full'}
  `}
  >
    <div className='flex gap-2 items-center '>
      <LogoMini size={size} className='animate-spin' />
      {!noText && <div className='text-gray-600 text-sm'>Loading</div>}
    </div>
  </div>
)

export default Loading
